import { EFeatureFlags } from 'constants/featureFlags'
import { AuthRoleNameEnum } from 'constants/user'
import routes from 'routes'

export interface SidebarItem {
  path: string
  name: string
  iconName?: string
  header?: string
  badge?: {
    variant: string
    text: string
  }
  allowedRoles?: AuthRoleNameEnum[]
  hideForViewer?: boolean
  featureFlag?: EFeatureFlags
  children?: SidebarItem[]
}

export enum ERouteName {
  DASHBOARD = 'Dashboard',
  REPORT = 'Reports',
  COLLECTION = 'Collections',
  DRAFT = 'Drafts',
  MESSAGE = 'Messages',
  NOTIFICATION = 'Notifications',
  USER = 'Users',
  GROUP = 'User Groups',
  ARCHIVE = 'Archives',
  COMMON_LIBRARY = 'Common Library',
  SETTING = 'Settings',
  DOCUMENT = 'Documents',
  OPERATION = 'Operations',
  ICON_BUILDER = 'Icon Builder',
  DOCUMENT_TYPE = 'Document Types',
  TAG = 'Tags',
  APPEARANCE = 'Appearance',
  SSO = 'SSO Configuration'
}

const dashboardRoutes: SidebarItem = {
  path: routes.dashboard.value,
  name: ERouteName.DASHBOARD,
  iconName: 'sidebar-dashboard'
}

const reportRoutes: SidebarItem = {
  path: routes.report.organization.value,
  name: ERouteName.REPORT,
  iconName: 'sidebar-report',
  allowedRoles: [AuthRoleNameEnum.ORG_ADMIN, AuthRoleNameEnum.ADMIN, AuthRoleNameEnum.BASIC_USER]
}

const draftRoutes: SidebarItem = {
  path: routes.processes.value,
  hideForViewer: true,
  name: ERouteName.DRAFT,
  iconName: 'sidebar-draft'
}
const collectionRoutes: SidebarItem = {
  path: routes.collections.value,
  name: ERouteName.COLLECTION,
  iconName: 'sidebar-collection'
}

const notificationRoutes: SidebarItem = {
  path: routes.notifications.value,
  name: ERouteName.NOTIFICATION,
  iconName: 'sidebar-notification',
  badge: {
    variant: 'success',
    text: '3'
  }
}

const messageRoutes: SidebarItem = {
  path: routes.messages.value,
  name: ERouteName.MESSAGE,
  iconName: 'sidebar-inbox'
}

const userRoutes: SidebarItem = {
  path: routes.users.value,
  name: ERouteName.USER,
  iconName: 'sidebar-user',
  allowedRoles: [AuthRoleNameEnum.ORG_ADMIN, AuthRoleNameEnum.ADMIN, AuthRoleNameEnum.BASIC_USER]
}

const groupRoutes: SidebarItem = {
  path: routes.groups.value,
  name: ERouteName.GROUP,
  iconName: 'sidebar-group',
  allowedRoles: [AuthRoleNameEnum.ORG_ADMIN, AuthRoleNameEnum.ADMIN]
}

const archiveRoutes: SidebarItem = {
  path: routes.archive.value,
  name: ERouteName.ARCHIVE,
  iconName: 'sidebar-archive'
}

const plansRoutes: SidebarItem = {
  path: routes.plans.value,
  name: 'Work Plans',
  iconName: 'sidebar-plans',
  featureFlag: EFeatureFlags.WORK_PLANS,
  allowedRoles: [AuthRoleNameEnum.ORG_ADMIN, AuthRoleNameEnum.ADMIN],
}

const commonLibraryRoutes: SidebarItem = {
  path: routes.commonLibrary.value,
  name: ERouteName.COMMON_LIBRARY,
  hideForViewer: true,
  iconName: 'sidebar-library'
}

const documentRoutes: SidebarItem = {
  path: '/',
  name: ERouteName.DOCUMENT,
  iconName: '',
  children: [draftRoutes, collectionRoutes, plansRoutes, archiveRoutes, commonLibraryRoutes]
}

const operationRoutes: SidebarItem = {
  path: '/',
  name: ERouteName.OPERATION,
  iconName: '',
  children: [reportRoutes, userRoutes, groupRoutes]
}

const settingRoutes: SidebarItem = {
  path: routes.setting.value,
  name: ERouteName.SETTING,
  iconName: 'sidebar-setting',
  allowedRoles: [AuthRoleNameEnum.ORG_ADMIN, AuthRoleNameEnum.ADMIN],
  children: [
    {
      path: routes.setting.iconBuilder.value,
      name: ERouteName.ICON_BUILDER,
      iconName: 'sidebar-icon-builder'
    },
    {
      path: routes.setting.documentType.value,
      name: ERouteName.DOCUMENT_TYPE,
      iconName: 'sidebar-document-type'
    },
    {
      path: routes.setting.tag.value,
      name: ERouteName.TAG,
      iconName: 'sidebar-tag'
    },
    {
      path: routes.setting.appearance.value,
      name: ERouteName.APPEARANCE,
      iconName: 'sidebar-appearance'
    },
    {
      path: routes.setting.sso.value,
      name: ERouteName.SSO,
      iconName: 'sidebar-sso',
      allowedRoles: [AuthRoleNameEnum.ORG_ADMIN],
    }
  ]
}

//* INFO: Temporarily hide
// const processDraftsRoutes: SidebarItem = {
//   path: '/process-drafts',
//   name: 'Process Drafts',
//   icon: 'las la-sticky-note'
// }

// const quizRoutes: SidebarItem = {
//   path: '/quizzes',
//   name: 'Quizzes',
//   icon: 'las la-school'
// }

// const trainingRoutes: SidebarItem = {
//   path: '/training',
//   name: 'Training',
//   icon: 'las la-industry'
// }

const knowHowRoutes = [
  dashboardRoutes,
  draftRoutes,
  collectionRoutes,
  plansRoutes,
  archiveRoutes,
  reportRoutes,
  userRoutes,
  // messageRoutes,
  // notificationRoutes,
  groupRoutes,
  // commonLibraryRoutes,
  settingRoutes
  // processDraftsRoutes,
  // quizRoutes,
  // trainingRoutes
]

const adminRoutes: SidebarItem[] = [dashboardRoutes, documentRoutes, operationRoutes, settingRoutes]

//* INFO: Temporarily hide
// const groupRoutes: SidebarItem = {
//   path: '/groups',
//   name: 'Groups',
//   icon: 'las la-users',
//   header: 'Manage'
// }

// const workflowRoutes: SidebarItem = {
//   path: '/workflows',
//   name: 'Workflows',
//   icon: 'las la-network-wired'
// }

// const documentTypeRoutes: SidebarItem = {
//   path: '/document-types',
//   name: 'DocumentTypes',
//   icon: 'las la-file-alt'
// }

// const tagRoutes: SidebarItem = {
//   path: '/tags',
//   name: 'Tags',
//   icon: 'las la-tags'
// }

// const courseRoutes: SidebarItem = {
//   path: '/courses',
//   name: 'Courses',
//   icon: 'las la-graduation-cap'
// }

// const quizManagementRoutes: SidebarItem = {
//   path: '/quiz-management',
//   name: 'Quizzes',
//   icon: 'uil-home-alt'
// }

// const locationRoutes: SidebarItem = {
//   path: '/locations',
//   name: 'Locations',
//   icon: 'las la-map-marker-alt'
// }

//* INFO: Temporarily hide
const manageRoutes: SidebarItem[] = [
  // groupRoutes,
  // userRoutes,
  // workflowRoutes,
  // documentTypeRoutes,
  // tagRoutes,
  // courseRoutes,
  // quizManagementRoutes,
  // locationRoutes
]

export const sidebarItems = [...knowHowRoutes, ...manageRoutes]
export const adminSidebarItems = adminRoutes
